export const BASE_IMG_PATH = "/assets/tray-designer/"

export const genUniqKey = () => String(Math.round(new Date().getTime() / 7000))

const key = genUniqKey()

export const trayVariants = [
  {
    src: `rectangular/Rectangular+Camtray+Black.jpg?${key}`,
    alt: "Rectangular Black",
    variant: "Rectangular",
  },
  {
    src: `round/Black-110.jpg?${key}`,
    alt: "Round Black",
    variant: "Round",
  },
  {
    src: `trapezoid/Black-110.jpg?${key}`,
    alt: "Trapezoid Black",
    variant: "Trapezoid",
  },
  // {
  //   src: "",
  //   alt: "",
  //   variant: "Edge-to-Edge"
  // }
]
